import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ListItem, Typography } from '@sm/wds-react';

import SMHeaderContext from '../../../SMHeaderContext';

export const SolutionByNeed = ({ title, url, name }) => {
  const { excludeMenuItems } = useContext(SMHeaderContext);

  if (excludeMenuItems.includes(name)) return null;

  return (
    <ListItem
      key={title}
      className="sm-nav-submenu__by-need-container"
      isNavigable
      navigationTarget={url}
    >
      <Typography
        variant="body"
        color="link"
        className="sm-nav-submenu__by-need"
      >
        {title}
      </Typography>
    </ListItem>
  );
};

export default SolutionByNeed;

SolutionByNeed.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};
